<template>
  <v-dialog v-model="localDialog" width="600px">
    <v-card>
      <v-card-title style="font-size: 28px; font-weight: 500">
        Devices
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-row no-gutters>
        <v-col cols="12" sm="1"></v-col>
        <v-col cols="12" sm="5" class="pr-2">
          <v-select
            v-model="audioDevices"
            :items="selectAudioDevices"
            label="Audio"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="5" class="pl-2">
          <v-select
            v-model="videoDevices"
            :items="selectVideoDevices"
            label="Video"
            outlined
          ></v-select>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="closeDialog"> บันทึก </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      devices: null,
      videoDevices: '',
      audioDevices: '',
      selectAudioDevices: [],
      selectVideoDevices: []
    }
  },
  computed: {
    ...mapState('dialog', ['dialogDevices']),
    localDialog: {
      get() {
        return this.dialogDevices
      },
      set(value) {
        this.setDialogDevice(value)
      }
    }
  },
  created() {
    this.getDevice()
  },
  methods: {
    ...mapActions('dialog', ['setDialogDevice', 'setUuidVideo', 'setUuidAudio']),
    closeDialog() {
      this.setDialogDevice(false)
      const valueAudioDevices = this.devices.filter(
        (deviceId) => deviceId.label === this.audioDevices
      )
      const valueVideoDevices = this.devices.filter(
        (deviceId) => deviceId.label === this.videoDevices
      )
      this.setUuidVideo(valueVideoDevices[0].deviceId)
      this.setUuidAudio(valueAudioDevices[0].deviceId)
      // console.log('audioDevices', valueAudioDevices[0].deviceId)
      // console.log('videoDevices', valueVideoDevices[0].deviceId)
    },

    getDevice() {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        this.devices = devices
        const audioDevices = devices.filter(
          (device) => device.kind === 'audioinput'
        )
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput'
        )
        this.audioDevices = audioDevices[0].label
        this.videoDevices = videoDevices[0].label
        this.selectAudioDevices = audioDevices.map((labels) => labels.label)
        this.selectVideoDevices = videoDevices.map((labels) => labels.label)
      })
    }
  }
}
</script>
